import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-clinical px-3 py-4 sm:px-6" data-id="element-70" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl items-start gap-2.5 rounded-md border border-teal/30 bg-white px-3 py-2.5" data-id="element-71" data-mp="1o3do2fp4sjsq">
        <ShieldCheckIcon className="mt-0.5 h-7 w-7 shrink-0 text-teal" strokeWidth={1.6} aria-hidden="true" data-id="element-72" data-mp="1x4bsgz3hetbu" />
        <div data-id="element-73" data-mp="19fsgo9l83yf0">
          <h2 className="font-heading text-[0.95rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.3rem]" data-id="element-74" data-mp="19fad0rw8ehx2">
            Your purchase is 100% protected
          </h2>
          <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-graphite sm:text-[0.9rem]" data-id="element-75" data-mp="1j5lt1ct6whkb">
            Explore RADIOLOGY VISUAL ATLAS™ for 7 days. Access the complete
            6-module study system and all 5 strategic bonuses. If it isn't right
            for you, contact us within 7 days for a full refund according to the
            refund terms.
          </p>
        </div>
      </div>
    </section>;
}